import styled from 'styled-components';
import {
  color,
  fontWeight,
  spacing,
  radius,
  fontSize,
  screen,
  container
} from '../../../../theme';

import { Button } from '@asgard/ui-library';

interface TabProps {
  active?: boolean;
  count?: number;
}

export const CategorySection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const StyledTags = styled.nav<TabProps>`
  display: none;

  @media (min-width: ${screen('lg')}) {
    display: flex;
    justify-content: center;
    padding: 0;
    white-space: nowrap;
    max-height: ${spacing('xl3')};
  }
`;

export const StyledTabElement = styled.div<TabProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${spacing('xs2')};
  padding: ${spacing('xs')} ${spacing('sm')};

  border-bottom: 2px solid
    ${({ active }) => (active ? color('emerald_500') : color('midnight_200'))};
  z-index: 2;
`;

export const TabLink = styled.a<TabProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing('xs')};

  font-weight: ${fontWeight('semiBold')};
  font-size: ${fontSize('md')};
  text-decoration: none;
  color: ${({ active }) =>
    active ? color('emerald_500') : color('midnight_600')};

  &:hover {
    color: ${color('midnight_400')};
  }
  &:focus,
  &:focus-visible {
    color: unset;
    outline: 3px solid ${color('emerald_250')};
    outline-offset: 8px;
    transition: none;
  }

  span.count {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    min-width: 22px;
    min-height: 22px;
    flex-shrink: 0;
    border-radius: ${radius('full')};
    border: 2px solid;
    border-color: ${({ active }) =>
      active ? color('emerald') : color('info_250')};
    font-size: 8px;
    font-weight: ${fontWeight('black')};
    text-align: center;
    background: ${({ active }) =>
      active ? color('emerald_100') : color('info_50')};
    color: ${({ active }) =>
      active ? color('emerald_500') : color('info_600')};
  }
`;

export const CategoryIconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  vertical-align: middle;

  svg,
  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
  }
`;

export const MobileButton = styled(Button)`
  display: flex;
  align-items: center;
  max-width: ${container('xs2')};
  gap: ${spacing('xs')};
  margin: ${spacing('sm')} 0;

  @media (min-width: ${screen('lg')}) {
    display: none !important;
  }
`;
